(function () {
  document.addEventListener('load', function () {
    var spinner = document.getElementById('initial-spinner');
    var messages = document.getElementById('unsupported-browser-message');

    if (spinner) spinner.classList.add('d-none');
    if (messages) messages.classList.add('show');
  });
})();
